import { TableCell } from "@mui/material";

import { useTenantTranslation } from "hooks/formatters";

import { TableRow } from "@mui/material";
import {
  LoadBasketLayerRead,
  LoadBasketRead,
} from "src/store/api/generatedApi";
import { Typography } from "@mui/material";
import { BasketMaterials } from "../types";
import { createMaterialKey } from "../utils";
import { useCraneDriver } from "../CraneDriverProvider";

const calculateBasketTotal = (layers: LoadBasketLayerRead[]): number =>
  layers.reduce((sum, layer) => sum + Math.round(layer.quantity.value), 0);

const calculateFilledBasketTotal = (
  basket: LoadBasketRead,
  basketMaterials: BasketMaterials
): number => {
  return basket.materials.reduce((sum, material) => {
    const key = createMaterialKey(
      basket.load_basket_id,
      material.material_name,
      material.layer_number
    );
    const addition = basket.additions.find(
      (addition) =>
        addition.material_name === material.material_name &&
        addition.layer_number === material.layer_number
    );
    if (addition) {
      return sum + addition.quantity.value;
    } else {
      const filledMass = basketMaterials[key]?.mass ?? material.quantity.value;
      return sum + Math.round(filledMass);
    }
  }, 0);
};

export const CraneTableTotalRow = () => {
  const { assignedLoads, basketMaterials } = useCraneDriver();
  const { t } = useTenantTranslation();

  return (
    <TableRow sx={{ backgroundColor: "rgba(0,0,0,0.05)" }}>
      <TableCell
        align="center"
        sx={{
          fontWeight: "bold",
          position: "sticky",
          left: 0,
          fontSize: { xs: 12, md: 14, lg: 16 },
          minWidth: { xs: 56, md: 72, lg: 96 },
          maxWidth: 120,
          backgroundColor: "rgba(0,0,0,0.05)",
        }}
      >
        {t("totalMass")}
      </TableCell>
      {assignedLoads.map((basket) => {
        const targetTotal = calculateBasketTotal(basket.materials);
        const adjustedTotal = calculateFilledBasketTotal(
          basket,
          basketMaterials
        );

        return (
          <TableCell
            key={`total-${basket.load_basket_id}`}
            className="total-mass-cell"
            data-loadbasketload_basket_id={basket.load_basket_id}
            data-targettotal={targetTotal}
            data-adjustedtotal={adjustedTotal}
            align="center"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: 24, md: 28, lg: 32 },
              minWidth: { xs: 280, md: 350, lg: 420 },
              maxWidth: { lg: 500 },
            }}
          >
            {adjustedTotal}
            <Typography
              variant="caption"
              display="block"
              sx={{ fontSize: { xs: 12, md: 14, lg: 16 } }}
            >
              {t("target")}: {targetTotal}
            </Typography>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
